var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortBoth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.178 21.8206L17.928 15.0706C18.1189 14.8797 18.2143 14.6537 18.2143 14.3926C18.2143 14.1314 18.1189 13.9054 17.928 13.7146C17.7372 13.5237 17.5112 13.4283 17.25 13.4283H1.74999C1.48883 13.4283 1.26283 13.5237 1.07198 13.7146C0.88113 13.9054 0.785706 14.1314 0.785706 14.3926C0.785706 14.6537 0.88113 14.8797 1.07198 15.0706L8.82198 21.8206C9.01283 22.0114 9.23883 22.1069 9.49999 22.1069C9.76115 22.1069 9.98716 22.0114 10.178 21.8206ZM8.82198 1.17885L1.07198 7.92885C0.88113 8.1197 0.785706 8.3457 0.785706 8.60686C0.785706 8.86803 0.88113 9.09403 1.07198 9.28488C1.26283 9.47573 1.48883 9.57115 1.74999 9.57115H17.25C17.5112 9.57115 17.7372 9.47573 17.928 9.28488C18.1189 9.09403 18.2143 8.86803 18.2143 8.60686C18.2143 8.3457 18.1189 8.1197 17.928 7.92885L10.178 1.17885C9.98716 0.988002 9.76115 0.892578 9.49999 0.892578C9.23883 0.892578 9.01283 0.988002 8.82198 1.17885ZM14.4722 7.57115L9.49999 3.24056L4.52783 7.57115H14.4722ZM4.52783 15.4283L9.49999 19.7589L14.4722 15.4283H4.52783Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortBoth);
export default __webpack_public_path__ + "static/media/sort-both.8a46104d1616a96d07e09a6ad72e6c70.svg";
export { ForwardRef as ReactComponent };